import type { DialogProps } from '@wartek-id/dialog-v1'
import { Dialog, DialogOverlay, DialogContent } from '@wartek-id/dialog-v1'
import { Text } from '@wartek-id/text-v1'
import { Icon } from '@wartek-id/icon-v2'
import { Button } from '@wartek-id/button-v1'

import { CardSchool } from './CardSchool'
import { PENGELOLAAN_KINERJA_KS_PENILAI_PATH } from 'app/KinerjaShared/constants/path'

import type { PelaksanaanSchool } from 'types/kinerja-pelaksanaan'

interface DialogSelectSchoolPerencanaanProps
  extends Omit<DialogProps, 'children'> {
  schools: PelaksanaanSchool[]
}

export function DialogSelectSchoolPerencanaan({
  isOpen,
  onClose,
  schools,
}: DialogSelectSchoolPerencanaanProps) {
  return (
    <Dialog
      isOpen={isOpen}
      onClose={onClose}
      customSize={484}
      autoFocus={false}
    >
      <DialogOverlay />
      <DialogContent className="p-6 m-auto self-center">
        <div className="flex justify-between items-center">
          <Text variant="heading-md">Pilih satuan pendidikan</Text>
          <Button
            color="white"
            iconOnly
            size="sm"
            variant="ghost"
            className="!outline-none"
            onClick={() => onClose()}
          >
            <Icon color="inherit" fontSize="lg">
              close
            </Icon>
          </Button>
        </div>
        <div className="flex flex-col mt-6 gap-4">
          {schools
            .filter(
              (thisSchool) =>
                thisSchool.perencanaanReadyState != 'COMPLETED' &&
                thisSchool.role == 'KS_DEFINITIF' &&
                thisSchool.confirmationStatus != 'REJECTED'
            )
            .map((thisSchool) => (
              <CardSchool
                fullWidth
                key={thisSchool.npsn}
                ctaText="Periksa"
                baseHref={`${PENGELOLAAN_KINERJA_KS_PENILAI_PATH}/periksa`}
                school={thisSchool}
                checkConfirmation={false}
              />
            ))}
        </div>
      </DialogContent>
    </Dialog>
  )
}
